import { render, staticRenderFns } from "./OrgSelectionAdmin.vue?vue&type=template&id=642dbb4b&scoped=true&"
import script from "./OrgSelectionAdmin.vue?vue&type=script&lang=js&"
export * from "./OrgSelectionAdmin.vue?vue&type=script&lang=js&"
import style0 from "./OrgSelectionAdmin.vue?vue&type=style&index=0&id=642dbb4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642dbb4b",
  null
  
)

export default component.exports